import React, {Component} from 'react';
import {Col, Grid, Row} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import Links from "../../../../utilities/linksConfig/Links";
import DaneWynajmu from "./components/DaneWynajmu";
import DanePlatnosci from "./components/DanePlatnosci";
import DaneKlienta from "./components/DaneKlienta";
import FormGroup from "react-bootstrap/es/FormGroup";
import ButtonToolbar from "react-bootstrap/es/ButtonToolbar";
import {TopButtonCancel, TopButtonSave} from "../../../../componentsTopsa/buttons/TopButtons";
import WynajemService from "../WynajemService";
import ValidatorMessages from "../../../../shared/validatorMessages/ValidatorMessages";
import ReactNotify from 'react-notify'
import moment from "moment";
import FormularzService from "./FormularzService";
import DaneOpis from "./components/DaneOpis";
import LogowanieService from "../../../logowanie/LogowanieService";
import {TopAlertOstrzezenie, TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";


export default class WynajemContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: '',
            kierowcy: [],
            pojazdy: [],
            formaPlatnosci: '',
            cenaKm: 0,
            liczbaKm: 0,
            czescStala: 0,
            kosztyKierowcow: 0,
            oplatyDrogowe: 0,
            pozostaleOplaty: 0,
            cenaWynajmu: 0,
            zaliczka: 0,
            pozostalo: 0,
            oplacone: '',
            faktura: '',
            dataOd: '',
            dataDo: '',
            godzinaOd: '00:00',
            godzinaDo: '23:59',
            tytul: '',
            miejsceDo: '',
            miejsceOd: '',
            kierowca: '',
            opis: '',
            status: '',
            samochod: '',
            liczbaPasazerow: '',
            vatNiemiecki: '',
            nazwa: '',
            telefon: '',
            email: '',
            uwagi: '',
            validatorMessages: '',
            loading: true
        };
    }

    componentWillMount() {

        if (this.props.match.params.id !== undefined) {
            WynajemService.getWynajemId(this.props.match.params.id)
                .then(function (response) {
                    let res = response.data.wynajem

                    let kierowcy = []
                    for (let i = 0; i < response.data.kierowcy.length; i++) {
                        kierowcy.push({
                            value: response.data.kierowcy[i].idKi,
                            label: response.data.kierowcy[i].imie + " " + response.data.kierowcy[i].nazwisko
                        })
                    }
                    let pojazdy = []
                    for (let i = 0; i < response.data.pojazdy.length; i++) {
                        pojazdy.push({
                            value: response.data.pojazdy[i].idPo,
                            label: response.data.pojazdy[i].marka + " " + response.data.pojazdy[i].model + " | " + response.data.pojazdy[i].nrRej + " | Miejsc: " + response.data.pojazdy[i].ileMiejsc
                        })
                    }
                    let kierowca = []
                    for (let i = 0; i < res.wynajemKierowcy.length; i++) {
                        kierowca.push(res.wynajemKierowcy[i].kierowca.idKi);
                    }

                    let pojazd = res.pojazd;

                    if (res.pojazd === null) {
                        pojazd = {idPo: 0}
                    }

                    let cenaKm, liczbaKm, czescStala, kosztyKierowcow, oplatyDrogowe, pozostaleOplaty, zaliczka,
                        cenaWynajmu;

                    if (res.cenaNajmu === null || res.cenaNajmu === undefined) {
                        cenaWynajmu = 0
                    } else {
                        cenaWynajmu = res.cenaNajmu
                    }
                    if (res.cenaKm === null || res.cenaKm === undefined) {
                        cenaKm = 0
                    } else {
                        cenaKm = res.cenaKm
                    }
                    if (res.ileKm === null || res.ileKm === undefined) {
                        liczbaKm = 0
                    } else {
                        liczbaKm = res.ileKm
                    }
                    if (res.cenaCzescStala === null || res.cenaCzescStala === undefined) {
                        czescStala = 0
                    } else {
                        czescStala = res.cenaCzescStala
                    }
                    if (res.kosztyKierowcow === null || res.kosztyKierowcow === undefined) {
                        kosztyKierowcow = 0
                    } else {
                        kosztyKierowcow = res.kosztyKierowcow
                    }
                    if (res.oplatyDrogowe === null || res.oplatyDrogowe === undefined) {
                        oplatyDrogowe = 0
                    } else {
                        oplatyDrogowe = res.oplatyDrogowe
                    }
                    if (res.pozostaleOplaty === null || res.pozostaleOplaty === undefined) {
                        pozostaleOplaty = 0
                    } else {
                        pozostaleOplaty = res.pozostaleOplaty
                    }
                    if (res.zaliczka === null || res.zaliczka === undefined) {
                        zaliczka = 0
                    } else {
                        zaliczka = res.zaliczka
                    }

                    this.setState({
                        data: res,
                        pojazdy: pojazdy,
                        kierowcy: kierowcy,
                        formaPlatnosci: res.formaPlatnosci,
                        cenaKm: cenaKm,
                        liczbaKm: liczbaKm,
                        czescStala: czescStala,
                        cenaWynajmu: cenaWynajmu,
                        kosztyKierowcow: kosztyKierowcow,
                        oplatyDrogowe: oplatyDrogowe,
                        pozostaleOplaty: pozostaleOplaty,
                        zaliczka: zaliczka,
                        opis: res.opis,
                        oplacone: res.zaplacono,
                        faktura: res.fakturaWystawiona,
                        dataOd: res.dataOd,
                        dataDo: res.dataDo,
                        godzinaOd: moment(res.dataOd).format("HH:mm").toString(),
                        godzinaDo: moment(res.dataDo).format("HH:mm").toString(),
                        tytul: res.tytul,
                        miejsceDo: res.miejsceDo,
                        miejsceOd: res.miejsceOd,
                        kierowca: kierowca,
                        samochod: pojazd.idPo,
                        status: res.status,
                        liczbaPasazerow: res.ileOsob,
                        vatNiemiecki: res.vatNiemiecki,
                        nazwa: res.klientNazwa,
                        telefon: res.klientTelefon,
                        email: res.klientEmail,
                        uwagi: res.klientUwagi
                    })
                }.bind(this))
        } else {
            FormularzService.getKierowcy()
                .then(function (response) {
                    let kierowcy = []
                    let res = response.data;
                    for (let i = 0; i < res.length; i++) {
                        kierowcy.push({value: res[i].idKi, label: res[i].imie + " " + res[i].nazwisko})
                    }
                    this.setState({kierowcy: kierowcy})
                }.bind(this))
            FormularzService.getPojazdy()
                .then(function (response) {
                    let pojazdy = []
                    let res = response.data.content;
                    for (let i = 0; i < res.length; i++) {
                        pojazdy.push({
                            value: res[i].idPo,
                            label: res[i].marka + " " + res[i].model + " | " + res[i].nrRej + " | Miejsc: " + res[i].ileMiejsc
                        })
                    }
                    this.setState({
                        pojazdy: pojazdy,
                        data: 'nowy'
                    })
                }.bind(this))
        }
    }

    czyMozeEdytowacFormularz = () => {

        // jest to edycja && nie ma roli wynajem bądz admin
        if (this.props.location.pathname !== '/konfiguracja/wynajem/formularz' && !LogowanieService.sprawdzCzyZalogowanyPosiadaRole(['ROLE_WYNAJEM'])) {
            return false
        } else return true;
    };

    onClickZapisz() {

        this.setState({validatorMessages: []})
        let poprawne = true;
        this.state.validatorMessages = [];

        if (!Boolean(this.state.miejsceOd) || !Boolean(this.state.miejsceDo) || !Boolean(this.state.dataDo) || !Boolean(this.state.dataOd) || !Boolean(this.state.liczbaPasazerow)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono wszystkich wymaganych pól w oknie Dane wynajmu')
        }
        if (!Boolean(this.state.nazwa) && !Boolean(this.state.telefon) && !Boolean(this.state.email)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono żadnego z pól identyfikujących klienta (telefon / email / nr dokumentu)')
        }
        if ((this.state.dataOd) > (this.state.dataDo)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Data wyjazdu nie może być późniejsza niż data przyjazdu')
        }

        if (poprawne) {
            let dataOd = this.state.dataOd;
            let dataDo = this.state.dataDo;

            if (localStorage.getItem('EBUS_EdycjaWynajem') !== null) {
                dataOd = this.state.dataOd.substr(0, 10);
                dataDo = this.state.dataDo.substr(0, 10);
            }

            let kierowcy = []


            let samochod = {
                "idPo": this.state.samochod,
            }

            if (this.state.samochod === null || this.state.samochod === '' || this.state.samochod === undefined || this.state.samochod === 0) {
                samochod = null
            }


            for (let i = 0; i < this.state.kierowca.length; i++) {
                if (Number.isInteger(this.state.kierowca[i])) {
                    kierowcy.push({
                        "id": 0,
                        "kierowca": {
                            "idKi": this.state.kierowca[i]
                        }
                    })
                } else {
                    kierowcy.push({
                        "id": 0,
                        "kierowca": {
                            "idKi": this.state.kierowca[i].value
                        }
                    })
                }
            }

            let cenaNajmu = this.state.cenaWynajmu;

            let data = {
                "cenaCzescStala": this.state.czescStala,
                "cenaKm": this.state.cenaKm,
                "cenaNajmu": cenaNajmu,
                "dataDo": dataDo + 'T' + this.state.godzinaDo,
                "dataOd": dataOd + 'T' + this.state.godzinaOd,
                "fakturaWystawiona": this.state.faktura,
                "formaPlatnosci": this.state.formaPlatnosci,
                "idKl": 0,
                "idWy": 0,
                "pojazd": samochod,
                "ileKm": this.state.liczbaKm,
                "ileOsob": this.state.liczbaPasazerow,
                "klientEmail": this.state.email,
                "klientNazwa": this.state.nazwa,
                "klientTelefon": this.state.telefon,
                "klientUwagi": this.state.uwagi,
                "kosztyKierowcow": this.state.kosztyKierowcow,
                "miejsceDo": this.state.miejsceDo,
                "miejsceOd": this.state.miejsceOd,
                "opis": this.state.opis,
                "oplatyDrogowe": this.state.oplatyDrogowe,
                "pozostaleOplaty": this.state.pozostaleOplaty,
                "status": this.state.status,
                "tytul": this.state.tytul,
                "vatNiemiecki": this.state.vatNiemiecki,
                "wynajemKierowcy": kierowcy,
                "zaliczka": this.state.zaliczka,
                "zaplacono": this.state.oplacone
            };

            if (localStorage.getItem('EBUS_EdycjaWynajem') !== null) {
                WynajemService.aktualizujWynajem((JSON.parse(localStorage.getItem('EBUS_EdycjaWynajem'))), data).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie zaktualizowano wynajem', "", 3000)
                        if (localStorage.getItem('kalendarz') !== null && localStorage.getItem('kalendarz') !== undefined) {
                            this.props.history.push('/konfiguracja/wynajem/kalendarz')
                        } else {
                            this.props.history.push('/konfiguracja/wynajem/lista')
                        }

                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas aktualizowania wynajmu', "", 3000)
                    }
                }.bind(this))
            } else {
                WynajemService.addWynajem(data).then(function (response) {
                    if (response.status < 300) {
                        this.refs.notificator.success('Pomyślnie dodano wynajem', "", 3000)
                        if (localStorage.getItem('kalendarz') !== null && localStorage.getItem('kalendarz') !== undefined) {
                            this.props.history.push('/konfiguracja/wynajem/kalendarz')
                        } else {
                            this.props.history.push('/konfiguracja/wynajem/lista')
                        }
                    }
                    else {
                        this.refs.notificator.error('Wystąpił błąd podczas dodawania wynajmu', "", 3000)
                    }
                }.bind(this))
            }
        }
    }


    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    render() {
        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                              history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}
            >
                <Grid fluid={true} id={'WynajemContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{
                                    addressUrl: '/konfiguracja',
                                    text: 'Konfiguracja'
                                }, {
                                    addressUrl: '/konfiguracja/wynajem',
                                    text: 'Wynajem'
                                }, {addressUrl: '/konfiguracja/wynajem/formularz', text: 'Formularz'}]}/>
                                <SubHeader currentLink={this.props.match.path}
                                           obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                            </div>
                        </Col>
                        {this.state.data !== '' && this.state.kierowcy.length > 0 && this.state.pojazdy.length > 0 ?
                            <Col sm={12}>
                                <Row>
                                    <DaneWynajmu
                                        data={this.state.data} pojazdy={this.state.pojazdy}
                                        kierowcy={this.state.kierowcy} kierowca={this.state.kierowca}
                                        pojazd={this.state.samochod}
                                        setDataOd={(dataOd) => this.setState({dataOd})}
                                        setDataDo={(dataDo) => this.setState({dataDo})}
                                        setGodzinaOd={(godzinaOd) => this.setState({godzinaOd})}
                                        setGodzinaDo={(godzinaDo) => this.setState({godzinaDo})}
                                        setMiejsceOd={(miejsceOd) => this.setState({miejsceOd})}
                                        setMiejsceDo={(miejsceDo) => this.setState({miejsceDo})}
                                        setTytul={(tytul) => this.setState({tytul})}
                                        setKierowca={(kierowca) => this.setState({kierowca})}
                                        setStatus={(status) => this.setState({status})}
                                        setSamochod={(samochod) => this.setState({samochod})}
                                        setLiczbaPasazerow={(liczbaPasazerow) => this.setState({liczbaPasazerow})}
                                        setVatNiemiecki={(vatNiemiecki) => this.setState({vatNiemiecki})}/>
                                    <DanePlatnosci
                                        data={this.state}
                                        setCenaWynajmu={(cenaWynajmu) => this.setState({cenaWynajmu})}
                                        setFormaPlatnosci={(formaPlatnosci) => this.setState({formaPlatnosci})}
                                        setCenaKm={(cenaKm) => this.setState({cenaKm})}
                                        setLiczbaKm={(liczbaKm) => this.setState({liczbaKm})}
                                        setCzescStala={(czescStala) => this.setState({czescStala})}
                                        setKosztyKierowcow={(kosztyKierowcow) => this.setState({kosztyKierowcow})}
                                        setOplatyDrogowe={(oplatyDrogowe) => this.setState({oplatyDrogowe})}
                                        setPozostaleOplaty={(pozostale) => this.setState({pozostale})}
                                        setZaliczka={(zaliczka) => this.setState({zaliczka})}
                                        setPozostalo={(pozostalo) => this.setState({pozostalo})}
                                        setOplacone={(oplacone) => this.setState({oplacone})}
                                        setFaktura={(faktura) => this.setState({faktura})}/>
                                </Row>
                                <Row>
                                    <DaneOpis
                                        data={this.state}
                                        setOpis={(opis) => this.setState({opis})}/>
                                    <DaneKlienta
                                        data={this.state}
                                        setNazwa={(nazwa) => this.setState({nazwa})}
                                        setTelefon={(telefon) => this.setState({telefon})}
                                        setEmail={(email) => this.setState({email})}
                                        setUwagi={(uwagi) => this.setState({uwagi})}/>
                                </Row>

                            </Col> : null}
                        <FormGroup>
                            <Col xs={12}>
                                <ValidatorMessages messages={this.state.validatorMessages}/>
                            </Col>
                            <Col xs={12} style={{marginBottom: 15}}>
                                <div className={'pull-right'}>
                                    <ButtonToolbar>
                                        <TopButtonCancel onClick={() => {
                                            if (localStorage.getItem('kalendarz') !== null && localStorage.getItem('kalendarz') !== undefined) {
                                                this.props.history.push('/konfiguracja/wynajem/kalendarz')
                                            } else {
                                                this.props.history.push('/konfiguracja/wynajem/lista')
                                            }
                                        }} text={'Anuluj'}/>

                                        {
                                            this.czyMozeEdytowacFormularz() &&

                                            <TopButtonSave onClick={() => {
                                                this.onClickZapisz()
                                            }}
                                                           text={'Zapisz wynajem'}/>

                                        }
                                    </ButtonToolbar>
                                    {
                                        !this.czyMozeEdytowacFormularz() &&
                                        <TopAlertOstrzezenie text={'Brak mozliwosci edycji'}/>

                                    }
                                </div>
                            </Col>
                        </FormGroup>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/formularz/FormularzContainer.js